import { t } from 'i18next'
import { Chart } from 'primereact/chart'
import { useEffect, useState } from 'react'
import {
  ApprenticeModuleGradeView,
  TimelineEnum,
} from '../../../../model/apprenticeModuleGrade.model'
import { useAppSelector } from '../../../../redux/hooks'
import { getModuleKey } from '../util/DatatableBodies'

export const ModuleStatistic = (props: {
  moduleGrades: ApprenticeModuleGradeView[]
}) => {
  const [chartDataCurrentModules, setChartDataCurrentModules] = useState({})
  const [chartDataPastModules, setChartDataPastModules] = useState({})

  const modules = useAppSelector((state) => state.apprenticeshipModules)
  const mGrades = props.moduleGrades

  const setupChart = (
    grades: ApprenticeModuleGradeView[],
    arrayType: TimelineEnum
  ) => {
    const documentStyle = getComputedStyle(document.documentElement)
    const moduleGradeSummary: {
      id: number
      label: string
      count: number
      grades: any[]
      id_grade_schema: number
    }[] = []
    mGrades
      .filter((m) => m.timeline_status === arrayType)
      .map((mg) => {
        const existingMgWithSameSchema = moduleGradeSummary.find(
          (l) =>
            l.id === mg.id_apprenticeship_module &&
            l.id_grade_schema === mg.module_grade.id_grade_schema
        )

        if (existingMgWithSameSchema) {
          existingMgWithSameSchema.count = existingMgWithSameSchema.count + 1
          if (mg.module_grade?.grade_value) {
            existingMgWithSameSchema.grades.push(mg.module_grade.grade_value)
          }
        } else {
          const newElement = {
            id: mg.id_apprenticeship_module,
            label: `${getModuleKey(mg, modules)} (S${mg.semester})`,
            count: 1,
            grades: mg.module_grade?.grade_value
              ? [mg.module_grade.grade_value]
              : [],
            id_grade_schema: mg.module_grade.id_grade_schema,
          }
          moduleGradeSummary.push(newElement)
        }
      })

    const data = {
      labels: moduleGradeSummary.map((y) => y.label),
      datasets: [
        {
          label: t<string>('core.statistic.grades.total_semester_container'),
          backgroundColor: documentStyle.getPropertyValue('--blue-500'),
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          data: moduleGradeSummary.map((y) => y.count),
          tension: 0.4,
        },
        {
          label: t<string>('core.statistic.grades.inserted_semester_container'),
          backgroundColor: documentStyle.getPropertyValue('--blue-800'),
          borderColor: documentStyle.getPropertyValue('--blue-800'),
          data: moduleGradeSummary.map((y) => y.grades.length),
          tension: 0.4,
        },
      ],
    }
    if (arrayType === TimelineEnum.present) {
      setChartDataCurrentModules(data)
    } else if (arrayType === TimelineEnum.past) {
      setChartDataPastModules(data)
    }
  }

  useEffect(() => {
    if (mGrades.length === 0) {
      setChartDataCurrentModules({})
      setChartDataPastModules({})
      return
    }

    setupChart(mGrades, TimelineEnum.present)
    setupChart(mGrades, TimelineEnum.past)
  }, [mGrades])

  return (
    <div>
      <div className={'grid w-full'}>
        <div className={'col-6'}>
          <Chart
            type={'bar'}
            data={chartDataCurrentModules}
            options={{
              maintainAspectRatio: false,
              aspectRatio: 1,
              indexAxis: 'y',
              responsive: true,
              plugins: {
                title: {
                  display: true,
                  text: t<string>('core.statistic.grades.current_grades.title'),
                },
                legend: {
                  labels: {
                    color: '#495057',
                  },
                },
              },
            }}
          />
          <p className={'small-text secondary-text'}>
            {t<string>('core.statistic.grades.current_grades.description')}
          </p>
        </div>
        <div className={'col-6'}>
          <Chart
            type={'bar'}
            data={chartDataPastModules}
            options={{
              indexAxis: 'y',

              maintainAspectRatio: false,
              aspectRatio: 1,
              responsive: true,
              plugins: {
                title: {
                  display: true,
                  text: t<string>('core.statistic.grades.past_grades.title'),
                },
                legend: {
                  labels: {
                    color: '#495057',
                  },
                },
              },
            }}
          />
          <p className={'small-text secondary-text'}>
            {t<string>('core.statistic.grades.past_grades.description')}
          </p>
        </div>
      </div>
    </div>
  )
}